// Wait until the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Check if the body element has the class "template-product"
  if (document.body.classList.contains("template-product")) {
    // Find the element with the classes "guarantee" and "section"
    var guaranteeSection = document.querySelector(".guarantee.section");
    
    // If the element exists
    if (guaranteeSection) {
      // Hide the element
      guaranteeSection.style.display = "none";

      // Check if the element also has the class "d-block"
      if (guaranteeSection.classList.contains("d-block")) {
        // Remove the class "d-block"
        guaranteeSection.classList.remove("d-block");
      }
    }
  }
});


